export interface AppQueryMeta {
  [key: string]: unknown;
  /**
   * Explicit allow-list switch for persisted query cache.
   * Queries are not persisted unless this is true.
   */
  persist?: boolean;
  /**
   * Marks payloads that must never be written to persisted cache.
   */
  sensitive?: boolean;
  /**
   * Useful hint for realtime-aware query orchestration.
   */
  realtime?: boolean;
}

declare module '@tanstack/react-query' {
  interface Register {
    queryMeta: AppQueryMeta;
    mutationMeta: AppQueryMeta;
  }
}

export const QUERY_META = {
  none: {} as AppQueryMeta,
  persistable: { persist: true, sensitive: false } as AppQueryMeta,
  sensitive: { persist: false, sensitive: true } as AppQueryMeta,
  realtime: { persist: false, realtime: true } as AppQueryMeta,
} as const;
